






























import {Component, PropSync, Prop, Vue} from 'vue-property-decorator';

/**
 * 역할 : 태그를 입력받는 input 과, 생성된 태그를 보여줄 div로 이루어진 태그 생성기
 * 흐름 : input에 태그명을 입력하고 스페이스, 엔터를 누르면 태그가 생성됨
 * 데이터 : 생성된 태그들로 이루어진 리스트가 'tagList' 이름으로 양방향 바인딩되어있음
 * 제한 : prop으로 넘겨받은 tagNumberLimit 값보다 많은 태그를 생성할 경우 'overflow' 이벤트를 발생시킴
 */


const KEY_FOR_MAKING_TAG = [' ', 'Enter'] // 태그를 생성할 수 있는 키 종류

@Component({})
export default class TagMaker extends Vue {
  @PropSync('tagList')
  private tagListSync: string[];
  @Prop({required: true})
  private readonly tagNumberLimit: number;
  private inputValue = '';

  private handleInput() {
    const reg = /[^a-zA-Z0-9ㄱ-힣]/g // 알파벳, 한글, 숫자 제외한 문자를 선택하는 정규식
    const isInvalid = this.inputValue.match(reg);
    if (isInvalid) {
      alert('입력 불가한 문자입니다.');
      this.inputValue = this.inputValue.replace(/[^a-zA-Z0-9ㄱ-힣]/g, '');
    }
  }

  private handleKeyPress(e: KeyboardEvent) {
    if (!KEY_FOR_MAKING_TAG.includes(e.key) || this.inputValue === '') return;

    if (!this.tagListSync.includes(this.inputValue)) {
      this.addTag(this.inputValue);
    }
    this.inputValue = '';
  }

  private addTag(targetTag: string) {
    if (this.tagListSync.length === this.tagNumberLimit) {
      this.$emit('overflow')
      return;
    }
    this.tagListSync = [...this.tagListSync, targetTag];
  }

  private removeTag(targetTag: string) {
    this.tagListSync = this.tagListSync.filter(tag => tag !== targetTag);
  }

}

